import React, { memo } from "react";

interface IClassificationPlaceholderIconProps {
  style?: React.CSSProperties;
}

const ClassificationPlaceholderIcon = ({
  style
}: IClassificationPlaceholderIconProps) => (
  <span style={style} className="threat threat-placeholder" />
);

export default memo(ClassificationPlaceholderIcon);
